import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Notifications = lazy(() => import('./Notifications'))

const notificationRoutes = [
  {
    path: '/notifications',
    component: Notifications,
    auth: authRoleAccess.collaboration_view,
  },
]

export default notificationRoutes
